import { createTheme } from '@/constants/risk-dashboard-colors'
import type { RADashboardTheme } from '@interfaces/raDashboard.interface'
import React, { PropsWithChildren, useEffect } from 'react'

export interface RADashboardThemeSettings {
  isDarkMode: boolean
  theme: RADashboardTheme
}

const initialValue: RADashboardThemeSettings = {
  isDarkMode: false,
  theme: createTheme(false),
}

export const RADashboardThemeContext = React.createContext(initialValue)

export default function RADashboardThemeContextProvider(
  props: PropsWithChildren<RADashboardThemeSettings>,
) {
  // Keep the benign "ResizeObserver loop" warning out of the dev error overlay.
  useEffect(() => {
    const handler = (e: ErrorEvent) => {
      if (e.message?.startsWith('ResizeObserver loop')) e.stopImmediatePropagation()
    }
    window.addEventListener('error', handler, true)
    return () => window.removeEventListener('error', handler, true)
  }, [])

  const settings: RADashboardThemeSettings = {
    isDarkMode: props.isDarkMode,
    theme: props.theme,
  }
  return (
    <RADashboardThemeContext.Provider value={settings}>
      {props.children}
    </RADashboardThemeContext.Provider>
  )
}
